import styled from 'styled-components';

export const Container = styled.div`
    overflow-y: scroll;
    padding: 20px 50px 50px 50px;
    height: 100%;
    background-color: ${props => props.theme.backgroundColor};
    display: flex;
    flex-direction: row;
    > * {
        padding: 5px;
    }
`;